import '../plugins/infiniteslidev2';

export default function initInfiniteSlide() {
    $('ul.infinite-slide').infiniteslide({
        speed: 50,
        pauseonhover: false
    });
}